import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    width: ", "px;\n    height: ", "px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { forwardRef } from 'react';
import styled from 'styled-components';
var StyledSvgIcon = styled.svg(_templateObject(), function (_ref) {
  var iconWidth = _ref.iconWidth;
  return iconWidth;
}, function (_ref2) {
  var iconHeight = _ref2.iconHeight;
  return iconHeight;
});
export var SvgIcon = forwardRef(function (_a, ref) {
  var _a$width = _a.width,
      iconWidth = _a$width === void 0 ? 24 : _a$width,
      _a$height = _a.height,
      iconHeight = _a$height === void 0 ? 24 : _a$height,
      _a$viewBox = _a.viewBox,
      viewBox = _a$viewBox === void 0 ? '0 0 24 24' : _a$viewBox,
      children = _a.children,
      props = __rest(_a, ["width", "height", "viewBox", "children"]);

  return React.createElement(StyledSvgIcon, Object.assign({
    xmlns: 'http://www.w3.org/2000/svg',
    focusable: 'false',
    width: '100%',
    height: '100%',
    viewBox: viewBox,
    ref: ref,
    iconWidth: iconWidth,
    iconHeight: iconHeight
  }, props), children);
});
SvgIcon.displayName = 'SvgIcon';